module.exports = __webpack_public_path__ + "static/media/pratik_kardile.9920ab31.png";